import script from "./DashBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashBoard.vue?vue&type=script&setup=true&lang=ts"

import "./DashBoard.vue?vue&type=style&index=0&id=64259c36&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64259c36"]])

export default __exports__